import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-canvas text-ink" data-id="element-28" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-29" data-mp="vtxoahhops0l">
        <h2 id="bonos" className="font-display text-3xl font-extrabold leading-none tracking-tight sm:text-4xl" data-id="element-30" data-mp="qu2vu9i9gudf">
          <span className="rounded-lg bg-highlight px-2 py-0.5 text-ink" data-id="element-31" data-mp="14s9kr058fk0y">
            5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-xl text-sm leading-snug text-ink/80" data-id="element-32" data-mp="zsn9uxcvmfvb">
          Y además recibís 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-success" data-id="element-33" data-mp="19k14aqpz0phl">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-34" data-mp="1nkvhdmnyreml">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col overflow-hidden rounded-xl border-2 border-brand bg-white text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="1jjryssej74ho" data-mpi={i}>
              <span className="bg-highlight px-2.5 py-1 font-sub text-sm font-semibold text-ink" data-id="element-36" data-mp="2kaz8vj1gsq8">
                Bono {i + 1} — Gratis
              </span>
              <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="cklesmsjqc8k">
                <h3 className="font-sub text-sm font-semibold leading-tight text-brand" data-id="element-38" data-mp="chz7mo9khyqv">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-ink/80 sm:text-sm" data-id="element-39" data-mp="lbu3t6spoeud">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-xs font-bold text-ink/80" data-id="element-40" data-mp="qaos2o9g6vlv">
                  Valor:{' '}
                  <span className="text-cta line-through decoration-2" data-id="element-41" data-mp="vc4fuo30fg7y">
                    {bono.value}
                  </span>
                </p>
              </div>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-highlight bg-brand px-3 py-2.5 leading-tight" data-id="element-42" data-mp="aiw86u6f035h">
          <p className="font-sub text-base font-semibold text-white" data-id="element-43" data-mp="kas6o6cexva8">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-white/80 line-through decoration-cta decoration-2" data-id="element-44" data-mp="fk222vbt9wgl">
              {BONUS_TOTAL}
            </span>
          </p>
          <p className="mt-1 font-display text-sm font-extrabold uppercase text-highlight" data-id="element-45" data-mp="t9vt9kasgsth">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}